export const CreditAnalysisTypes = {
  SET_CREDIT_PROPERTY_REF: 'SET_CREDIT_PROPERTY_REF',
  SET_CREDIT_TENANTS: 'SET_CREDIT_TENANTS',
  SET_CREDIT_ANALYSIS: 'SET_CREDIT_ANALYSIS',
  SET_CREDIT_FIADOR: 'SET_CREDIT_FIADOR',
  SET_CREDIT_INVITE_EMAILS: 'SET_CREDIT_INVITE_EMAILS',
}
